import React, { useState, useEffect } from "react"
import { post } from "./../utils/apiClient"
import { FAX_ACTION, DEFAULT_APP_ID, PERSONAL_FAX } from "./../utils/constants"
//import SendFaxFormModal from "./sendFaxFormModal"
import ViewTab from "./faxTabs/view"
import History from "./faxTabs/history"
import { getOriginatingFaxNumberForHeader } from "./../utils/common"
import { TriangleAlert } from "lucide-react"

const viewTabs = [
  {
    key: "view",
    label: "View",
  },
  {
    key: "history",
    label: "History",
  },
]

const FaxView = ({
  selectedFax,
  fetchFaxes,
  tab,
  selectedQueue,
  authUser,
  onClose,
  allPermissions,
  copiedFaxType,
}) => {
  const [loading, setLoading] = useState(false)
  const [document, setDocument] = useState(null)
  const [selectedViewTab, setSelectedViewTab] = useState(viewTabs[0].key) // Default to first tab
  // const faxNumberToDisplay =
  //   tab === "outbound"
  //     ? selectedFax.destination_fax_csid || selectedFax?.destination_fax_number
  //     : selectedFax.originating_fax_tsid

  const faxNumberToDisplay = getOriginatingFaxNumberForHeader(selectedFax, tab)

  //const showFrwdBottons = selectedQueue.faxNumberAttributes.length === 0
  const showFrwdBottons = true

  const handleTabClick = (key) => {
    setSelectedViewTab(key) // Update selected tab on click
  }

  const fetchFax = async () => {
    const viewPermission =
      selectedQueue?.faxNumber === PERSONAL_FAX
        ? true
        : selectedQueue.type === "folder"
          ? selectedQueue?.permissions?.READ?.FAX_VIEW
          : selectedFax?.permissions?.READ?.FAX_VIEW

    if (!viewPermission) {
      return
    }

    try {
      setLoading(true)

      // let faxNumber =
      //   tab === "outbound"
      //     ? selectedFax.destination_fax_csid
      //     : selectedFax.originating_fax_tsid
      // if (selectedQueue.type === "subfolder") {
      //   faxNumber = selectedFax?.faxNumber
      // }

      const headers = {
        faxNumber: selectedQueue?.faxNumber || selectedFax?.faxNumber,
        faxAction:
          selectedQueue.type === "folder"
            ? FAX_ACTION[tab]
            : FAX_ACTION[copiedFaxType.toLowerCase()],
        appId: selectedQueue?.appId || selectedFax?.appId || DEFAULT_APP_ID,
        originatingFaxNumber: faxNumberToDisplay,
        queueName: selectedQueue?.queue || selectedFax?.copiedFromQueue || "",
        faxType: selectedFax?.faxType || tab.toUpperCase(),
      }

      const data = await post(
        `/fax/image`,
        {
          userId: selectedFax?.userId || selectedQueue?.userId,
          faxId: selectedFax.fax_id || selectedFax.faxId,
        },
        headers,
      )

      if (data) {
        // const byteCharacters = atob(data?.image)
        // const byteNumbers = new Array(byteCharacters.length)
        // for (let i = 0; i < byteCharacters.length; i++) {
        //   byteNumbers[i] = byteCharacters.charCodeAt(i)
        // }
        // const byteArray = new Uint8Array(byteNumbers)
        // const blob = new Blob([byteArray], { type: "application/pdf" })

        // // Update state to pass the Blob to the Document component
        // setPdfUrl(blob)
        setDocument(data)
      } else {
        setDocument(null)
      }

      setLoading(false)
    } catch (err) {
      setLoading(false)
      setDocument(null)
    }
  }

  const renderTabContent = () => {
    switch (selectedViewTab) {
      case "view":
        return selectedQueue?.faxNumber === PERSONAL_FAX ||
          (selectedQueue.type === "folder"
            ? selectedQueue?.permissions?.READ?.FAX_VIEW
            : selectedFax?.permissions?.READ?.FAX_VIEW) ? (
          <ViewTab
            base64String={document?.image}
            selectedFax={selectedFax}
            loading={loading}
          />
        ) : (
          <div style={{ padding: "10px", display: "flex", alignItems: "center", gap: "6px" }}>
            <TriangleAlert size={18} fill="yellow" stroke="black" style={{ marginRight: "5px", verticalAlign: "middle" }} />
            You do not have permission to view the fax.
          </div>
        )
      case "history":
        return selectedQueue?.faxNumber === PERSONAL_FAX ||
          (selectedQueue.type === "folder"
            ? selectedQueue?.permissions?.READ?.FAX_HISTORY_VIEW
            : selectedFax?.permissions?.READ?.FAX_HISTORY_VIEW) ? (
          <History
            selectedFax={selectedFax}
            faxNumberToDisplay={faxNumberToDisplay}
            authUser={authUser}
          />
        ) : (
          <div style={{ padding: "10px", display: "flex", alignItems: "center", gap: "6px" }}>
            <TriangleAlert size={18} fill="yellow" stroke="black" style={{ marginRight: "5px", verticalAlign: "middle" }} />
            You do not have permission to view the history.
          </div>
        )
      default:
        return <div>Please select a tab</div>
    }
  }

  useEffect(() => {
    const faxId = selectedFax?.fax_id || selectedFax?.faxId

    if (faxId) fetchFax()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFax?.fax_id, selectedFax?.faxId])

  return (
    <div className="checkbox-popup-overlay">
      <div className="view-popup-modal">
        <div className="checkbox-popup-header">
          <h3 className="popup-title">Fax view</h3>

          {document && document?.fax_read && (
            <span
              style={{
                background: "#ffff95",
                padding: "5px",
                fontSize: "12px",
              }}
            >
              Fax has already been viewed
            </span>
          )}
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
        <div className="fax-view">
          {(selectedQueue?.type !== "subfolder" || showFrwdBottons) && (
            <div className="fax-view-tabs">
              {viewTabs.map((viewTab) => (
                <div
                  key={viewTab.key}
                  className={`tab ${
                    selectedViewTab === viewTab.key ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick(viewTab.key)}
                >
                  {viewTab.label}
                </div>
              ))}
            </div>
          )}

          {(selectedQueue?.type !== "subfolder" || showFrwdBottons) && (
            <div className="fax-view-data">
              <div className="data-item">
                <span className="data-label">Fax Number:</span>
                <span className="data-value">{faxNumberToDisplay}</span>
              </div>
              <div className="data-item">
                <span className="data-label">Fax Id:</span>
                <span className="data-value">
                  {selectedFax.fax_id || selectedFax.faxId}
                </span>
              </div>
            </div>
          )}

          <div className="fax-view-image">{renderTabContent()}</div>

          {/* {showCancelPopup && (
            <CancelConfirmationPopup
              showCancelPopup={showCancelPopup}
              onConfirm={() => handleCancelFax()}
              onCancel={() => setShowCancelPopup(null)}
              actionLoading={actionLoading}
            />
          )} */}

          {/* {showFFPopup && (
        <SendFaxFormModal
          onSave={handleSendFax}
          actionLoading={actionLoading}
          onClose={() => {
            setShowFFPopup(null)
          }}
          selectedQueue={selectedQueue}
          selectedFax={selectedFax}
          // document={document}
        />
      )} */}

          {/* {showFUPopup && (
            <SendUserForm
              onSave={handleSendToUser}
              actionLoading={actionLoading}
              onClose={() => {
                setShowFUPopup(null)
              }}
              selectedQueue={selectedQueue}
              selectedFax={selectedFax}
              document={document}
            />
          )} */}
        </div>
      </div>
    </div>
  )
}

export default FaxView

// const SendUserForm = ({
//   onClose,
//   onSave,
//   actionLoading,
//   selectedQueue,
//   selectedFax,
// }) => {
//   const [email, setEmail] = useState("")
//   const [emailSubject, setEmailSubject] = useState("")
//   const [emailMessage, setEmailMessage] = useState("")
//   const [errorMessage, setErrorMessage] = useState("")

//   const handleSubmit = (e) => {
//     e.preventDefault()

//     if (!email) {
//       setErrorMessage("Email is required.")
//       return
//     } else {
//       if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
//         setErrorMessage("Email is incorrect.")
//         return
//       }
//     }

//     if (!emailSubject) {
//       setErrorMessage("Subject is required.")
//       return
//     }

//     if (!emailMessage) {
//       setErrorMessage("Message is required.")
//       return
//     }

//     const formData = {
//       recipientEmail: email.trim(),
//       subject: emailSubject,
//       bodyText: emailMessage,
//       userId: selectedQueue?.userId,
//       faxId: selectedFax?.fax_id,
//       appId: selectedFax?.appId,
//       faxNumber: selectedFax?.faxNumber,
//     }

//     onSave(formData)
//   }

//   return (
//     <div className="popup-overlay">
//       <div className="popup">
//         {actionLoading ? (
//           <div className="loading" style={{ padding: "20px" }}>
//             In progress ...
//           </div>
//         ) : (
//           <>
//             <div className="checkbox-popup-header">
//               <h3 className="popup-title">Forward To User</h3>
//               <button
//                 type="button"
//                 onClick={onClose}
//                 style={{
//                   background: "transparent",
//                   border: "none",
//                   fontSize: 24,
//                   cursor: "pointer",
//                 }}
//               >
//                 ×
//               </button>
//             </div>
//             <form
//               className="popup-group form-container"
//               onSubmit={handleSubmit}
//             >
//               <div className="form-group">
//                 <label htmlFor="email">
//                   Email: <span className="mandatory">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>

//               <div className="form-group">
//                 <label htmlFor="emailSubject">
//                   Subject: <span className="mandatory">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="emailSubject"
//                   value={emailSubject}
//                   onChange={(e) => setEmailSubject(e.target.value)}
//                 />
//               </div>

//               <div className="form-group">
//                 <label htmlFor="emailMessage">
//                   Message: <span className="mandatory">*</span>
//                 </label>
//                 <textarea
//                   id="emailMessage"
//                   value={emailMessage}
//                   onChange={(e) => setEmailMessage(e.target.value)}
//                   style={{
//                     width: "100%",
//                     minHeight: "80px",
//                     resize: "vertical",
//                   }}
//                 ></textarea>
//               </div>

//               {errorMessage && (
//                 <div className="error-message">{errorMessage}</div>
//               )}

//               <div className="popup-buttons">
//                 <button
//                   type="button"
//                   className="popup-button cancel"
//                   onClick={onClose}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" className="popup-button save">
//                   Send
//                 </button>
//               </div>
//             </form>
//           </>
//         )}
//       </div>
//     </div>
//   )
// }

